<template>
  <div>
    <ots-main-title></ots-main-title>
    <div class="applyManageAddBox">
      <h1>{{ planInfo.name }}</h1>
      <el-form
        :model="customForm"
        :rules="customRules"
        ref="customForm"
        label-width="130px"
        class="demo-ruleForm"
        :validate-on-rule-change="false"
      >
        <div>
          <el-form-item label="选择批次" class="mb20" prop="planId">
            <el-select
              v-model="customForm.planId"
              clearable
              placeholder="请选择"
              :disabled="isEdit"
            >
              <el-option
                v-for="item in examBatchList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <h2>基础信息</h2>
          <!-- 系统配置项 -->
          <el-form-item label="姓名" prop="realName">
            <el-input
              v-model.trim="customForm.realName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="证件类型" prop="cardType">
            <el-select
              :disabled="isEdit"
              v-model.trim="customForm.cardType"
              placeholder="请选择"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="item in cardTypeList"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号" prop="cardNo">
            <el-input
              :disabled="isEdit"
              v-model="customForm.cardNo"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select v-model="customForm.sex" placeholder="请选择">
              <el-option label="女" :value="0"></el-option>
              <el-option label="男" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号" prop="phone" v-if="baseDefList.isShowPhone">
            <el-input
              v-model="customForm.phone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email" v-if="baseDefList.isShowEmail">
            <el-input
              v-model="customForm.email"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <!-- 基础照片 -- 不必须 -- photo -->
          <el-form-item label="基础照片" class="upload-img" v-show="planInfo.photoContrastType == 2">
            <div class="avatarTip">
              <el-upload action="" :show-file-list="false" :before-upload="beforeAvatarUpload" :http-request="uploadImgUrl">
                <div class="photo">
                  <img v-if="customForm.photoDefault" :src="customForm.photoDefault" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
              <div class="upload-tips">
                <p class="col_grayQ">
                  请上传用于人脸对比的基础照片，请务必保证照片的真实性
                </p>
              </div>
            </div>
          </el-form-item>

          <!-- 报名照片 -- 必须 -- photoUrl -->
          <el-form-item label="报名照片" prop="photo" class="upload-img">
            <div class="avatarTip">
              <el-upload action="" :show-file-list="false" :before-upload="beforeAvatarUpload" :http-request="uploadImg">
                <div class="photo">
                  <img v-if="customForm.photo" :src="customForm.photo" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
              <div class="upload-tips">
                <p class="col_grayQ" v-if="planInfo.photoDescription">
                  {{ planInfo.photoDescription }}
                </p>
                <p class="col_grayQ" v-else>
                  必须是报考人本人真实免冠照片，不许带眼镜，照片应清晰可识别身份，过于模糊的照片无法上报成功。
                </p>
                <p class="col_grayQ">
                  图片支持
                  <span style="color: #fe5958">
                    {{ planInfo.photoFormat ? planInfo.photoFormat : "jpg" }}
                  </span>
                  格式，文件最大不超过
                  <span style="color: #fe5958">
                    {{ planInfo.photoSize ? planInfo.photoSize : "2048" }} kb
                  </span>
                </p>
                <el-button type="primary" style="margin-top: 20px" round v-if="isEdit" @click="deletePicLog">删除照片上传记录</el-button>
              </div>
            </div>
          </el-form-item>

          <!-- 自定义表单项 -->
          <el-form-item
            :label="item.displayName"
            v-for="item in studentsInfo"
            :key="item.id"
            :class="{
              'upload-img': item.type == 'imageUpload',
              address: item.type == 'textarea',
            }"
            :prop="item.name"
          >
            <!-- (1) 基础信息, 自定义 - 下拉选项 -->
            <el-select
              v-model="customForm[item.name]"
              :placeholder="item.placeholder ? item.placeholder : '请选择'"
              v-if="
                item.type == 'province' ||
                item.type == 'select' ||
                item.type == 'subject' ||
                item.type == 'politicalStatus' ||
                item.type == 'nation'
              "
              @change="$forceUpdate()"
              value-key="item"
            >
              <el-option
                :value="data.name"
                v-for="(data, i) in item.valueVo"
                :key="i"
                :label="data.name"
              ></el-option>
            </el-select>

            <!-- (2) 基础信息, 自定义 - 时间格式 ( YYYY-MM-DD) -->
            <el-date-picker
              v-model="customForm[item.name]"
              type="date"
              value-format="yyyy-MM-dd"
              v-if="item.type == 'date'"
              :placeholder="item.placeholder ? item.placeholder : '选择日期'"
              @input="$forceUpdate()"
            ></el-date-picker>

            <!-- (3) 基础信息, 自定义 - 时间格式 ( YYYY-MM-DD HH:mm:ss) -->
            <el-date-picker
              v-model="customForm[item.name]"
              v-if="item.type == 'datetime'"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="
                item.placeholder ? item.placeholder : '选择日期时间'
              "
              @input="$forceUpdate()"
            ></el-date-picker>

            <!-- (4) 基础信息, 自定义 - 图片上传 ( beforeAvatarUploadExt 自定义图片上传配置 ) -->
            <div class="avatarTip" v-if="item.type == 'imageUpload'">
              <el-upload
                action=""
                :data="{ '0': item.name }"
                :show-file-list="false"
                :before-upload="
                  (file) => {
                    return beforeAvatarUploadExt(
                      file,
                      item.fileBack,
                      item.filesize
                    );
                  }
                "
                :http-request="uploadImgExt"
              >
                <div class="photo">
                  <img
                    v-if="customForm[item.name]"
                    :src="customForm[item.name]"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
              <div class="upload-tips">
                <p class="col_grayQ">{{ item.remarks }}</p>
                <p class="col_grayQ">
                  图片支持
                  <span style="color: #fe5958">{{ item.fileBack }}</span>
                  格式，文件最大不超过
                  <span style="color: #fe5958"> {{ item.filesize }} kb</span>
                </p>
              </div>
            </div>

            <!-- (5) 基础信息, 自定义 - 单行文本格式 -->
            <el-input
              type="text"
              v-model.trim="customForm[item.name]"
              v-if="item.type == 'text' && item.dataType == 0"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              @change="isUseRule($event, item.name)"
            ></el-input>

            <!-- (6) 基础信息, 自定义 - 单行文本格式 - 非数字 -->
            <el-input
              type="text"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              v-model="customForm[item.name]"
              v-if="item.type == 'text' && item.dataType == 1"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              @change="isUseRule($event, item.name)"
              auto-complete="off"
            ></el-input>

            <!-- (7) 基础信息, 自定义 - 多行文本格式 -->
            <el-input
              type="textarea"
              v-model="customForm[item.name]"
              v-if="item.type == 'textarea'"
              @change="isUseRule($event, item.name)"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
            ></el-input>

            <!-- (8) 基础信息, 自定义 - 生日日期格式 ( 根据身份证号码自动配置 ) -->
            <el-date-picker
              v-model="customForm[item.name]"
              type="date"
              value-format="yyyy-MM-dd"
              v-if="item.type == 'birthday'"
              :placeholder="item.placeholder ? item.placeholder : '选择生日'"
              @input="$forceUpdate()"
            >
            </el-date-picker>

            <!-- (9) 基础信息, 自定义 - 省市级联数据 ( 读取配置 js 文件获取 ) -->
            <el-cascader
              size="large"
              v-model="customForm[item.name]"
              :options="item.valueVo"
              :props="{ value: 'name', label: 'name', children: 'cityList' }"
              v-if="item.type == 'provinceCity'"
              @change="changeCity($event, item.name)"
            >
            </el-cascader>
          </el-form-item>
        </div>

        <!-- ----------- 院校信息 ----------- -->
        <div>
          <h2>院校信息</h2>

          <!-- 院校下拉列表, 院校用户禁用 -->
          <el-form-item label="就读院校" prop="schoolId">
            <el-select
              v-model="customForm.schoolId"
              placeholder="请选择"
              :disabled="unSchool"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="item in schoolList"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 教学点下拉列表, 教学点用户禁用 -->
          <el-form-item :label="isSetStateName" prop="stationId">
            <el-select
              v-model="customForm.stationId"
              placeholder="请选择"
              :disabled="unStation"
              @change="changeStation"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="item in stationIdList"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- 院校信息自定义部分 -->
          <el-form-item
            :label="item.displayName"
            v-for="item in schoolInfo"
            :key="item.id"
            :class="{
              'upload-img': item.type == 'imageUpload',
              address: item.type == 'textarea',
            }"
            :prop="item.name"
          >
            <!-- (1) 基础信息, 自定义 - 下拉选项 -->
            <!-- (!!!) 自定义下拉数据同时包含 层次(level), 专业(subject) 时, 重新配置二者下拉选项 (isLevelAndSubject) -->
            <el-select
              v-model="customForm[item.name]"
              :placeholder="item.placeholder ? item.placeholder : '请选择'"
              v-if="
                item.type == 'province' ||
                item.type == 'select' ||
                item.type == 'subject' ||
                item.type == 'politicalStatus' ||
                item.type == 'nation' ||
                item.type == 'level'
              "
              @change="
                (item.type == 'level' || item.type == 'subject') && LscPlugs
                  ? isLevelAndSubject(item.type, item.name, $event)
                  : $forceUpdate()
              "
            >
              <el-option
                :value="data.name"
                v-for="(data, i) in item.valueVo"
                :key="i"
                :label="data.name"
              ></el-option>
            </el-select>

            <!-- (2) 基础信息, 自定义 - 时间格式 ( YYYY-MM-DD) -->
            <el-date-picker
              v-model="customForm[item.name]"
              type="date"
              value-format="yyyy-MM-dd"
              v-if="item.type == 'date'"
              :placeholder="item.placeholder ? item.placeholder : '选择日期'"
              @input="$forceUpdate()"
            >
            </el-date-picker>

            <!-- (3) 基础信息, 自定义 - 时间格式 ( YYYY-MM-DD HH:mm:ss) -->
            <el-date-picker
              v-model="customForm[item.name]"
              v-if="item.type == 'datetime'"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="
                item.placeholder ? item.placeholder : '选择日期时间'
              "
              @input="$forceUpdate()"
            >
            </el-date-picker>

            <!-- (4) 基础信息, 自定义 - 图片上传 ( beforeAvatarUploadExt 自定义图片上传配置 ) -->
            <div class="avatarTip" v-if="item.type == 'imageUpload'">
              <el-upload
                action=""
                :data="{ '0': item.name }"
                :show-file-list="false"
                :before-upload="(file) => { return beforeAvatarUploadExt(
                      file,
                      item.fileBack,
                      item.filesize
                    );
                  }
                "
                :http-request="uploadImgExt"
              >
                <div class="photo">
                  <img v-if="customForm[item.name]" :src="customForm[item.name]"/>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
              <div class="upload-tips">
                <p class="col_grayQ">{{ item.remarks }}</p>
                <p class="col_grayQ">
                  图片支持
                  <span style="color: #fe5958">{{ item.fileBack }}</span>
                  格式，文件最大不超过
                  <span style="color: #fe5958"> {{ item.filesize }} kb</span>
                </p>
              </div>
            </div>

            <!-- (5) 基础信息, 自定义 - 单行文本格式 -->
            <el-input
              type="text"
              v-model.trim="customForm[item.name]"
              v-if="item.type == 'text' && item.dataType == 0"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              @change="isUseRule($event, item.name)"
            ></el-input>

            <!-- (6) 基础信息, 自定义 - 单行文本格式 - 非数字 -->
            <el-input
              type="text"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              v-model="customForm[item.name]"
              v-if="item.type == 'text' && item.dataType == 1"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              @change="isUseRule($event, item.name)"
              auto-complete="off"
            ></el-input>

            <!-- (7) 基础信息, 自定义 - 多行文本格式 -->
            <el-input
              type="textarea"
              v-model="customForm[item.name]"
              v-if="item.type == 'textarea'"
              @change="isUseRule($event, item.name)"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
            ></el-input>
          
            <!-- (8) 基础信息, 自定义 - 生日日期格式 ( 根据身份证号码自动配置 ) -->
            <el-date-picker
              v-model="customForm[item.name]"
              type="date"
              value-format="yyyy-MM-dd"
              v-if="item.type == 'birthday'"
              :placeholder="item.placeholder ? item.placeholder : '选择日期'"
              @input="$forceUpdate()"
            >
            </el-date-picker>

            <!-- (9) 基础信息, 自定义 - 省市级联数据 ( 读取配置 js 文件获取 ) -->
            <el-cascader
              size="large"
              v-model="customForm[item.name]"
              :options="item.valueVo"
              :props="{ value: 'name', label: 'name', children: 'cityList' }"
              v-if="item.type == 'provinceCity'"
              @change="changeCity($event, item.name)"
            >
            </el-cascader>
          </el-form-item>
        </div>

        <!-- 报考信息部分 -->
        <div>
          <h2>报考信息</h2>

          <!-- 批次配置 "报名选择考点场次" ==> 显示 -->
          <el-form-item label="选择考点" prop="placeId" v-if="isUseTestSite">
            <el-select v-model="customForm.placeId" placeholder="请选择">
              <el-option
                :label="item.placeName"
                :value="item.placeId"
                v-for="item in placeListInfo"
                :key="item.placeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <div v-if="!isUseTestSite">
            <!-- 批次配置 "报名选考点场次" ==> 不显示  -->
            <el-form-item
              label="报考课程"
              prop="checkList"
              v-if="signCoureCount == 0"
            >
              <el-checkbox-group v-model="customForm.checkList">
                <el-checkbox
                  v-for="item in courseList"
                  :label="item.courseId"
                  :key="item.courseId"
                  :disabled="courseDisabled"
                  >{{ item.courseName }}</el-checkbox
                >
                <!-- 158b5f88-d125-4d98-a2b2-aa1eefca8760 -->
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="报考课程" prop="checkList" v-else>
              <el-radio-group v-model="customForm.checkList">
                <el-radio
                  v-for="item in courseList"
                  :label="item.courseId"
                  :key="item.courseId"
                  :disabled="courseDisabled"
                  >{{ item.courseName }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </div>
          <div v-if="optionalExam == 1">
            <el-form-item label="预约考试日期：" prop="schoolId">
              <el-select
                v-model="customForm.optionalExamDate"
                placeholder="请选择"
                class="timeClass"
                v-if="everyBodyLimitShow > 0"
              >
                <el-option
                  :label="
                    item.examDate +
                    ' 已预约' +
                    item.examCount +
                    '人可预约' +
                    item.leftCount +
                    '人'
                  "
                  :value="item.id"
                  v-for="item in examTime"
                  :key="item.id"
                ></el-option>
              </el-select>
              <el-select
                v-model="customForm.optionalExamDate"
                placeholder="请选择"
                class="timeClass"
                v-else
              >
                <el-option
                  :label="item.examDate + ' 已预约' + item.examCount + '人'"
                  :value="item.id"
                  v-for="item in examTime"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 批次配置 "报名选择考点场次" ==> 显示 -->
          <div>
            <el-form-item
            label="科目&时间"
            v-if="isUseTestSite"
            :prop="!isUseTestSite ? '' : 'courseSessionIds'"
          >
            <div v-for="(item, i) in courseList" :key="item.courseId">
              <div style="font-size: 14px; color: #45494d">
                {{ item.courseName }}
              </div>
              <el-radio-group
                v-model="customForm.courseSessionIds[i]"
                v-if="isRefreshDom"
              >
                <!-- @click.native="changeIsActive(i, item.timeAndSessionId[index])" -->
                <!-- :disabled="val.isUsable == 1"  -->
                <!--  'is-active': isUseEditSessionIds.indexOf(item.timeAndSessionId[index].sessionId) != -1} -->
                <el-radio-button
                  :disabled="val.isUsable == 1"
                  @click.native="
                    val.isUsable == 1
                      ? ''
                      : changeIsActive(i, item.timeAndSessionId[index])
                  "
                  :label="item.timeAndSessionId[index]"
                  :class="{ examType: true }"
                  v-for="(val, index) in item.timeAndSessionId"
                  :key="val.sessionId"
                >
                  {{ val.beginTime }} -- {{ val.endTime }}
                </el-radio-button>
              </el-radio-group>
            </div>
          </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
//裁剪图片
import { VueCropper } from "vue-cropper";
// vuex 辅助函数
import { mapMutations,mapState } from "vuex";
// 查询所有院校
import { getQueryAllSchool } from "@/http/modules/school";
// 查询所有教学点
import { getQueryAllStation } from "@/http/modules/station";
// 自定义部分相关接口
import {
  addStudentExtSet,
  UpdateRegistration,
  selectOneSignUp,
  uploadExtSet,
  getSignDateCount,
} from "@/http/modules/custom";
// 手机号码验证规则
import { checkPhone } from "../../common/verify";
// 专业层次相关接口
import {
  getLSCRelation,
  selectPlugs,
  getLevelListByRelationFN,
} from "@/http/modules/baseSet/majorCourse";
// 课程时间相关接口
import { getPlaceList, courseListTime } from "@/http/modules/baseSet/examSite";
import {
  getSinglePlan,
  getSelectPlanFn,
} from "@/http/modules/examSet/examBatch";
export default {
  components: {
    VueCropper,
  },
  name: "applyAdd",
  data() {
    return {
      signCoureCount: "",
      // 测试数据
      courseSession: [],
      /* ** 用户新增失败, 如手机号重复, 不在报名时间内等, 存储原始照片数据, 避免二次上传 ** */
      savePhoto: "",
      /* ** 自定义表单配置数据 ** */
      customForm: {
        planId: "",
        // 课程列表
        checkList: [],
        // 课程&时间 列表
        courseSessionIds: [],
        schoolId: "",
        optionalExamDate: "",
      },
      /* ** 表单校验规则 ( 只包含 "固定字段" 以及 "报考信息" , 自定义校验规则动态配置 ) */
      customRulesStorage: {},
      customRules: {
        planId: [{ required: true, message: "请选择批次", trigger: "blur" }],
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请输入性别", trigger: "blur" }],
        // phone: [
        //   {
        //     required: true,
        //     message: "请输入正确的手机号",
        //     trigger: "blur",
        //     validator: checkPhone,
        //   },
        // ],
        cardType: [
          { required: true, message: "请选择证件类型", trigger: "blur" },
        ],
        cardNo: [{ required: true, message: "请输入证件号", trigger: "blur" }],
        schoolId: [{ required: true, message: "请选择学校", trigger: "blur" }],
        stationId: [
          { required: true, message: "请选择函数站", trigger: "blur" },
        ],
        checkList: [
          { required: true, message: "请选择课程", trigger: "change" },
        ],
        address: [
          {
            required: true,
            message: "由于疫情防控要求，请填写居住地详细地址",
            trigger: "blur",
          },
        ],
        photo: [{ required: true, message: "请上传照片", trigger: "change" }],
        placeId: [{ required: true, message: "请选择考点", trigger: "blur" }],
        courseSessionIds: [
          { required: true, message: "请选择科目&时间", trigger: "change" },
        ],
      },
      /* ** 地址栏参数 ** */
      query: {},
      /* ** 所选批次ID ( 当前批次ID 或者 地址栏批次ID) ** */
      planId: "",
      /* ** 院校下拉数据 ** */
      schoolList: [],
      /* ** 教学点下拉数据 */
      stationIdList: [],
      /* ** 课程多选数据 ** */
      courseList: [],
      /* ** 证件类型 ** */
      // cardTypeList: [
      //   { id: 1, name: "身份证" },
      //   { id: 2, name: "护照" },
      //   { id: 3, name: "士官证" },
      //   { id: 4, name: "港澳台身份证" },
      // ],
      /* ** 专业下拉列表 ** */
      subject: [],
      /* ** 所选批次信息 ** */
      planInfo: {
        photoContrastType: 1,
        photoSize: "2048",
        photoFormat: "jpg",
      },
      /* ** 管理员权限 ** */
      roleType: "",
      /* ** 开关: 是否院校管理员 ** */
      unSchool: false,
      /* ** 开关: 是否教学点管理员 ** */
      unStation: false,
      /* ** 基础信息 ( 包含自定义部分 ) ** */
      studentsInfo: [],
      /* ** 院校信息 ( 包含院校部分 ) ** */
      schoolInfo: [],
      /* ** 出生日期 ** */
      birthday: "",
      /* ** 省市级联 ** */
      provinceCity: [],
      /* ** 开关: 用于判断图片是否需要进行格式数据处理 ** */
      changePhoto: false,
      changePhotoDefault: false,
      /* ** 教学点标题 ** */
      isSetStateName: "",
      /* ** 图片验证规则 ** */
      basicsMapImgRules: "",
      /* ** 专业字段名 ** */
      subjectName: "",
      /* ** 层次字段名 ** */
      levelName: "",
      /* ** 层次-专业-课程 配置数据 ** */
      LscJson: [],
      /* ** 层次-专业-课程 是否联动 ** */
      LscPlugs: "",
      /* ** 存储当前批次设置课程 ** */
      courseListConst: [],
      /* ** 课程选项禁用 ** */
      courseDisabled: false,
      /* ** 考点集合 ** */
      placeListInfo: [],
      /* ** 课程列表存储 ** */
      filterCourseList: [],
      /* ** 考点是否可用 ** */
      isUseTestSite: false,
      /* *** 用户信息是否配置完成 *** */
      isReadySignUp: false,
      /* *** 是否开启考点监听 *** */
      watchPlace: 0,
      /* *** 是否刷新DOM *** */
      isRefreshDom: true,
      /* *** 存储场次信息 *** */
      timeAndSessionIdDtoList: [],
      /* *** 是否取消选中场次 *** */
      isClickTheCourseList: false,
      /* *** 默认场次Id集合 *** */
      isUseEditSessionIds: [],
      /* *** 存储场次信息,用于取消选中功能 *** */
      isUseCourseAndSessionIds: [],
      isCanToast: true,
      examBatchList: [],
      optionalExam: "",
      everyBodyLimitShow: "",
      examTime: {},
      savePhotoDefault: "",
      baseDefList: {},
    };
  },
  computed: {
    ...mapState(['cardTypeList']),
    /* *** 判断当前页面功能: 添加/修改 *** */
    isEdit() {
      return this.$route.query.stuid ? true : false;
    },
    isShowMessage() {
      if (this.watchPlace > 2 && this.LscPlugs && this.$route.query.stuid) {
        return true;
      } else if (
        this.watchPlace > 0 &&
        this.LscPlugs &&
        !this.$route.query.stuid
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    /* *** 监听证件类型, 根据证件类型处理出生日期 *** */
    "customForm.cardNo": "autoSetBitrhday",
    /* *** 选择了考点 & 当前批次已获取 => 查询科目时间 *** */
    "customForm.placeId": "autoSetListTime",

    /* *** 课程列表改变,清空科目&时间勾选值 *** */
    courseList: "courseListIsChange",
    "customForm.planId": function () {
      this.changePlanId();
      this.getSignDateCountFn();
    },
  },
  created() {
    this.$store.dispatch('fetchCardTypeList');
    this.getSystemName();
  },
  mounted() {
    if (this.$route.query.planId) {
      this.customForm.planId = this.$route.query.planId;
      // this.getCourse();
    }
    this.SAVE_PAGE_THIS(this);
    // 获取初始化数据
    this.initDate();
    // 教学点标题
    this.getExamBatch();
    this.isSetState();
    this.getSignDateCountFn();
  },
  methods: {
    getSystemName() {
      this.$api.system.getSystemNameFN({ tenant: window.localStorage.getItem("tenant") }).then((res) => {
        let phoneObj = res.data.baseDefList.find((item) => item.fieldName == "phone");
        if(phoneObj) {
          this.baseDefList.isMastPhone = phoneObj.required == 1 ? true : false;
          this.baseDefList.isShowPhone = phoneObj.showInPage == 1 ? true : false;
        }
        let emailObj = res.data.baseDefList.find((item) => item.fieldName == "email");
        if(emailObj) {
          this.baseDefList.isMastEmail = emailObj.required == 1 ? true : false;
          this.baseDefList.isShowEmail = emailObj.showInPage == 1 ? true : false;
        }
        let rules = { ...this.customRules };
        if(this.baseDefList.isMastPhone){
          rules.phone = [
            {
              required: true,
              message: "请输入正确的手机号",
              trigger: "blur",
              validator: checkPhone
            },
          ];
        }
        if(this.baseDefList.isMastEmail){
          rules.email = [
            {
              required: true,
              message: "请输入正确的邮箱",
              trigger: "blur"
            },
            {
              message: "邮箱格式错误",
              trigger: "blur",
              type: "email"
            }
          ];
        }
        this.customRules = rules;
      })
    },
    getSignDateCountFn() {
      getSignDateCount({ planId: this.customForm.planId }).then((res) => {
        if (res.data && res.data != 1) {
          this.examTime = res.data;
          this.everyBodyLimitShow = this.examTime[0].everyBodyLimit;
        }
      });
    },
    ...mapMutations(["SAVE_PAGE_THIS"]),
    //导入、新增批次列表
    getExamBatch() {
      getSelectPlanFn({ needAudit: 5 }).then((res) => {
        if (res.code === 1) {
          this.examBatchList = res.data;
          //如只有一个则默认选择第一个
          if (res.data.length === 1) {
            // this.customForm.planId = res.data[0].id;
            if (this.LscPlugs) {
              this.resetLscFn();
            }
            // this.getLSCRelation()
            // this.upLoadImgForm.planId = res.data[0].id;
          }
        }
      });
    },
    changePlanId() {
      // 获取当前批次信息
      this.getPlan();
      // 获取课程列表
      this.getCourse();
      if (this.LscPlugs) {
        this.resetLscFn();
      }
    },

    /********************************************
     * @this 教学点改变-->获取考点
     ********************************************/
    changeStation(val) {
      if (!this.customForm.planId || !val) {
        return false;
      } else {
        //(1)考点是否可用
        if (this.isUseTestSite) {
          //(2)获取课程时间
          getPlaceList({ planId: this.customForm.planId, stationId: val }).then(
            (res) => {
              this.placeListInfo = res.data;
              if (res.data.length == 1) {
                this.customForm.placeId = res.data[0].placeId;
              } else {
                this.customForm.placeId = "";
              }
            }
          );
        } else {
          return false;
        }
      }
    },

    /********************************************
     * @this 课程列表改变-->清空科目&时间勾选值
     ********************************************/
    courseListIsChange(val) {
      for (let key in val) {
        this.customForm.courseSessionIds[key] = {};
        this.timeAndSessionIdDtoList[key] = {};
        if (val[key].timeAndSessionId) {
          val[key].timeAndSessionId.map((e) => {
            this.isUseCourseAndSessionIds.map((item) => {
              if (
                item.courseId == e.courseId &&
                item.sessionId == e.sessionId
              ) {
                this.customForm.courseSessionIds[key] = e;
                this.timeAndSessionIdDtoList[key] = e;
              }
            });
          });
        }
      }
      this.customForm.courseSessionIds = this.isClickTheCourseList
        ? []
        : this.timeAndSessionIdDtoList;
    },

    /********************************************
     * @this 考点改变-->查询科目&时间
     ********************************************/
    autoSetListTime(val) {
      if (this.isUseTestSite) {
        this.customForm.courseSessionIds = [];
        if (val && this.customForm.planId) {
          this.getListTime();
        } else if (!val) {
          this.courseList = [];
        }
      }
    },

    /********************************************
     * @this 科目&时间取消选中(修改DOM样式)
     ********************************************/
    changeIsActive(i, e) {
      if (this.isUseEditSessionIds.indexOf(e.sessionId) != -1) {
        for (let key in this.isUseEditSessionIds) {
          if (this.isUseEditSessionIds[key] == e.sessionId) {
            delete this.isUseEditSessionIds[key];
          }
        }
      }
      this.isClickTheCourseList = true;
      if (
        this.customForm.courseSessionIds[i] &&
        e.sessionId == this.customForm.courseSessionIds[i].sessionId
      ) {
        this.customForm.courseSessionIds[i] = {};
        this.isRefreshDom = false;
        this.$nextTick(() => {
          this.isRefreshDom = true;
        });
      }
    },

    /***************************************
     * @this 设置初始数据
     ***************************************/
    initDate() {
      /* ** 自定义字段配置 ** */
      this.mixin_setUserExtInfo()
        .then((res) => {
          res.data.map((e) => {
            /* ** 自定义基础信息 / 自定义院校信息 ** */
            if (e.title == 1) {
              // (1) 学生基础信息部分
              this.studentsInfo.push(e);
            } else if (e.title == 2) {
              // (2) 院校信息部分
              this.schoolInfo.push(e);
            }
            // (1) birthday 出生日期
            if (e.type == "birthday") {
              this.birthday = e.name;
              // (2) 层次
            } else if (e.type == "level") {
              this.levelName = e.name;
              // (3) 专业
            } else if (e.type == "subject") {
              this.subjectName = e.name;
            }
          });

          // 拼接: 表单配置数据
          this.customForm = Object.assign({}, this.customForm, res.customForm);
          // 拼接: 表单校验规则
          this.customRules = Object.assign(this.customRules, res.customRules);
          // 栈控件深度拷贝表单校验，用于 input 类型 修改表单校验
          this.customRulesStorage = JSON.parse(JSON.stringify(Object.assign(this.customRules, res.customRules)));
          // 根据页面功能 ( 添加/修改 ) 配置表单默认数据
          this.setEditDate();
          // 强制更新视图
          this.$forceUpdate();
          this.mixin_getCommonInfo().then((res) => {
            this.roleType = res.roleType;
            if (res.roleType == 2) {
              this.customForm.schoolId = res.schoolId;
              this.unSchool = true;
              this.unStation = false;
            } else if (res.roleType == 3) {
              this.unStation = true;
              this.unSchool = false;
              this.customForm.stationId = res.stationId;
            }
          });
          // 自定义是否同时设置了层次,专业 ( 层次, 专业, 课程 是否联动 )
          return selectPlugs({ levelType: "level", subjectType: "subject" });
        })
        .then((res) => {
          if (res.data == "true") {
            // (1) 配置联动的 层次,专业,课程数据
            this.LscPlugs = true;
            this.resetLscFn();
          } else {
            // (2) 不做联动
            this.LscPlugs = false;
            return false;
          }
        });
      /* ** 用户权限判断: 院校/教学点 ** */

      /* ** 配置院校下拉数据 ** */
      getQueryAllSchool({ state: 1 }).then((res) => {
        if (res.code) {
          this.schoolList = res.data;
        }
      });

      /* ** 配置教学点下拉数据 ** */
      getQueryAllStation({ state: 1 }).then((res) => {
        this.stationIdList = res.data;
      });
    },

    /*****************************************
     * @this 层次专业联动时,重新配置专业课程
     *****************************************/
    resetLscFn() {
      // 获取层次
      this.schoolInfo.map((e) => {
        if (e.name == this.levelName) {
          getLevelListByRelationFN().then((res) => {
            e.valueVo = res.data;
          });
        }
      });

      getLSCRelation({ planId: this.customForm.planId }).then((res) => {
        this.LscJson = res.data;
        // (1) 清空专业
        this.schoolInfo.map((e) => {
          if (e.type == "subject") {
            e.valueVo = [];
          }
        });
        // (2) 清空课程
        this.courseList = [];
        /* ** 处理: 层次-专业-课程 JSON 数据 ** */
        if (this.customForm[this.levelName]) {
          res.data.map((e) => {
            if (this.customForm[this.levelName] == e.levelName) {
              e.subjectVoList.map((m) => {
                // (3) 配置专业数据
                let s = { id: m.subjectId, name: m.subjectName };
                this.schoolInfo.map((e) => {
                  if (e.type == "subject") {
                    e.valueVo.push(s);
                    e.valueVo = [...this.newLscList(e.valueVo)];
                  }
                });
                // (4) 配置课程
                if (this.customForm[this.subjectName]) {
                  // (6) 配置课程
                  if (m.subjectName == this.customForm[this.subjectName]) {
                    m.courseVoList.map((isin) => {
                      if (this.courseListConst.indexOf(isin.courseId) != -1) {
                        this.courseList.push(isin);
                      }
                    });
                  }
                } else {
                  // (6) 配置课程
                  m.courseVoList.map((isin) => {
                    if (this.courseListConst.indexOf(isin.courseId) != -1) {
                      this.courseList.push(isin);
                    }
                  });
                }
              });
            }
          });
        } else {
          res.data.map((e) => {
            e.subjectVoList.map((m) => {
              // (5) 配置专业数据
              let s = { id: m.subjectId, name: m.subjectName };
              this.schoolInfo.map((e) => {
                if (e.type == "subject") {
                  e.valueVo.push(s);
                  e.valueVo = [...this.newLscList(e.valueVo)];
                }
              });
              if (this.customForm[this.subjectName]) {
                // (6) 配置课程
                if (m.subjectName == this.customForm[this.subjectName]) {
                  m.courseVoList.map((isin) => {
                    if (this.courseListConst.indexOf(isin.courseId) != -1) {
                      this.courseList.push(isin);
                    }
                  });
                }
              } else {
                // (6) 配置课程
                m.courseVoList.map((isin) => {
                  if (this.courseListConst.indexOf(isin.courseId) != -1) {
                    this.courseList.push(isin);
                  }
                });
              }
            });
          });
        }

        // (5) 课程去重
        this.courseList = [...this.newCourseList(this.courseList)];

        // (!!) 保留一下课程列表 ( 配置 "专业&时间" 时, 会修改课程列表 this.courseList, 在此处保留一份相同数据, 用作之后筛选课程 )
        this.filterCourseList = [...this.newCourseList(this.courseList)];

        // (6) 检测课程列表变化
        this.isHaveCourseList();

        // (7) 获取考试时间,重新配置课程数据 ( 考点没有变化, 无法查出时间数据 )
        if (this.isUseTestSite) {
          this.getListTime();
        }
      });
    },

    /**********************************************
     * @this 层次专业每次变化时,更新专业课程状态
     **********************************************/
    isLevelAndSubject(type, name, value) {
      /* ** 每次切换层次专业清空课程勾选数据 ** */
      this.customForm.checkList = [];
      /* ** 每次切换清空课程列表 ** */
      this.courseList = [];
      this.LscJson.map((e) => {
        // (1) 层次修改
        if (type == "level" && value == e.levelName) {
          // (2) 专业选项重置为空, 需要重新选择
          this.customForm[this.subjectName] = "";
          // (3) 找到专业下拉数据
          this.schoolInfo.map((item) => {
            if (item.type == "subject") {
              // (4) 清空原始专业下拉数据
              item.valueVo = [];
              // (5) 重新配置专业下拉数据
              e.subjectVoList.map((sub) => {
                let s = { id: sub.subjectId, name: sub.subjectName };
                item.valueVo.push(s);
              });
            }
          });
          // (6) 先清空课程列表, 再获取该专业下所有课程
          e.subjectVoList.map((cou) => {
            cou.courseVoList.map((isin) => {
              // (7) 当前批次课程包含
              if (this.courseListConst.indexOf(isin.courseId) != -1) {
                this.courseList.push(isin);
              }
            });
            // (8) 去重
            this.courseList = [...this.newCourseList(this.courseList)];
            // (9) 重新存储一份课程列表, 用于之后筛选数据
            this.filterCourseList = [...this.newCourseList(this.courseList)];
          });
        }
        // (1) 专业变化
        if (type == "subject") {
          // (2) 获取当前层次
          if (this.customForm[this.levelName]) {
            // (3) 层次已经选择了, 再变化专业设置课程
            if (e.levelName == this.customForm[this.levelName]) {
              e.subjectVoList.map((m) => {
                // (4) 专业名称符合
                if (m.subjectName == value) {
                  // (5) 获取课程列表
                  m.courseVoList.map((isin) => {
                    if (this.courseListConst.indexOf(isin.courseId) != -1) {
                      this.courseList.push(isin);
                    }
                  });
                  // (6) 课程去重
                  this.courseList = [...this.newCourseList(this.courseList)];
                  // (7) 重新储存一份课程列表, 用于之后筛选
                  this.filterCourseList = [
                    ...this.newCourseList(this.courseList),
                  ];
                }
              });
            }
          } else {
            // (2) 获取专业名称
            e.subjectVoList.map((m) => {
              // (3) 专业名称符合
              if (m.subjectName == value) {
                // (4) 获取课程列表
                m.courseVoList.map((isin) => {
                  if (this.courseListConst.indexOf(isin.courseId) != -1) {
                    this.courseList.push(isin);
                  }
                });
                // (5) 课程去重
                this.courseList = [...this.newCourseList(this.courseList)];
                // (6) 重新储存一份课程列表, 用于之后筛选
                this.filterCourseList = [
                  ...this.newCourseList(this.courseList),
                ];
              }
            });
          }
        }
      });
      /* ** 如果考点信息存在, 查询场次信息 ** */
      if (this.customForm.placeId) {
        this.getListTime();
      }
      // 检测课程列表变化
      this.isHaveCourseList();
      // 强制更新视图
      this.$forceUpdate();
    },

    /***************************************
     * @this 检测课程列表变化
     ***************************************/
    isHaveCourseList() {
      // (1) 课程未配置, 添加提示;
      if (this.courseList.length == 0) {
        this.$message.warning(
          "层次专业对应课程未配置，请前往专业课程设置中配置！"
        );

        // (2) 课程只有一门, 默认选中禁用
      } else if (this.courseList.length == 1) {
        // signCoureCount == 0 ? 多科: 单科
        if (this.signCoureCount == 0) {
          this.customForm.checkList.push(this.courseList[0].courseId);
        } else {
          this.customForm.checkList = this.courseList[0].courseId
        }
        this.courseDisabled = true;
        
        // (3) 多门课程, 自主选择
      } else if (this.courseList.length > 1) {
        this.courseDisabled = false;
      }
    },

    /************************************
     * @this 获取考试时间,重新配置课程数据
     ************************************/
    getListTime() {
      this.watchPlace++;
      /* ** 参数: 考点, 批次 ** */
      let params = {
        placeId: this.customForm.placeId,
        planId: this.customForm.planId,
      };
      /* ** 获取 科目&时间 接口 ** */
      courseListTime(params).then((res) => {
        // (1) 接口访问成功
        if (res.code == 1) {
          // (2) 没有同时配置层次专业, 不联动
          if (!this.LscPlugs) {
            // (3) 没有 "层次 - 专业" 联动关系, 直接配置课程
            this.courseList = res.data;
          } else {
            // 新增: 未配置课程提示
            let notSetCourse = [];
            // (4) "层次 - 专业" 与课程有联动, 根据 "层次, 专业" 配置课程
            let courseListIds = []; // ==> 用于存储课程 ID
            // (5) 重置课程列表为空; (courseList 和 filterCourseList 存储着一样的课程数据)
            this.courseList = [];
            // (6) 配置所有的课程 ID 集合, 方便从中筛选
            this.filterCourseList.map((e) => {
              courseListIds.push(e.courseId);
            });
            // (7) 筛选 "科目&时间 中获取的课程";
            res.data.map((e) => {
              if (courseListIds.indexOf(e.courseId) != -1) {
                this.courseList.push(e);
              } else {
                notSetCourse.push(e.courseName);
              }
              // (8) 课程去重, 避免重复数据报错(根据课程id: courseId)
              this.courseList = [...this.newCourseList(this.courseList)];
            });
            if (notSetCourse.length > 0 && this.isShowMessage) {
              if (this.isCanToast) {
                let that = this;
                this.isCanToast = false;
                this.$message.warning(
                  `课程“${notSetCourse.join("，")}”未在“专业课程设置”中配置`
                );
                setTimeout(() => {
                  that.isCanToast = true;
                }, 2000);
              }
            }
          }
        }
      });
    },

    /**
     * @param { Input 修改校验规则 }
     **/
    isUseRule(val1, val2) {
      const { required } = this.customRulesStorage[val2][0]
      if (!required) this.customRules[val2][0].required = val1 ? true: false
    },

    /***********************************
     * @isSetState 系统是否设置了教学点标题
     ***********************************/
    isSetState() {
      this.$api.system.getConfigData().then((res) => {
        let stationName = "";
        res.data.configList.map((e) => {
          // 1. 教学点标题
          if (e.setName == "stationName") {
            stationName = e.setValue2;
            // 2. 照片上传要求
          } else if (e.setName == "stuImgCondition") {
            e.setShowText = e.setShowText
              ? e.setShowText
              : "1. 必须是报考人本人真实免冠照片，不许带眼镜，照片应清晰可识别身份，过于模糊的照片无法上报成功。";
            e.setValue2 = e.setValue2 ? e.setValue2 : "jpeg";
            e.setValue = e.setValue ? e.setValue : "2345";
            this.basicsMapImgRules = e;
          }
        });
        this.isSetStateName = "教学点";
      });
    },

    /**************************
     * @changeCity 省市级联
     *************************/
    changeCity(e, item) {
      if (this.provinceCity.includes(item)) {
        return false;
      } else {
        this.provinceCity.push(item);
      }
    },

    /***************************
     * @this 数组对象去重(根据id)
     ***************************/
    newLscList(arr) {
      let map = new Map();
      for (let item of arr) {
        if (!map.has(item.id)) {
          map.set(item.id, item);
        }
      }
      return [...map.values()];
    },

    /***************************
     * @this 数组对象去重(根据课程id)
     ***************************/
    newCourseList(arr) {
      let map = new Map();
      for (let item of arr) {
        if (!map.has(item.courseId)) {
          map.set(item.courseId, item);
        }
      }
      return [...map.values()];
    },

    /***************************************
     * @this 如果是编辑,设置默认数据
     ***************************************/
    setEditDate() {
      // (1) 获取要编辑用户所在批次
      // this.planId = this.$route.query.planId;
      // (2) 判断是否有用户 ID
      if (this.$route.query.stuid) {
        // (3) 修改页面信息
        document
          .querySelector(".el-breadcrumb")
          .querySelector(".currentBread")
          .querySelector(".el-breadcrumb__inner").innerText = "修改报缴信息";
        // (4) 配置查询用户信息参数
        this.query = this.$route.query;
        let { stuid, planId } = this.query;
        let querySelectOne = {
          planId,
          stuIds: stuid,
        };
        // (5) 查询该批次,该用户信息
        selectOneSignUp(querySelectOne)
          .then((res) => {
            // isUsable == 1 场次报满 ==> 不选中
            if (res.data.timeAndSessionIdDtoList) {
              res.data.timeAndSessionIdDtoList.map((e, i) => {
                if (e.isUsable == 1) {
                  res.data.timeAndSessionIdDtoList[i] = {};
                }
              });
            }
            this.customForm.optionalExamDate = res.data.optionalExamDate;
            // 场次比对
            this.timeAndSessionIdDtoList = res.data.timeAndSessionIdDtoList ? res.data.timeAndSessionIdDtoList : [];
            // 场次绑定数据
            this.customForm.courseSessionIds = res.data.timeAndSessionIdDtoList ? res.data.timeAndSessionIdDtoList : [];
            // sessionId 集合
            this.isUseEditSessionIds = res.data.timeAndSessionIdDtoList ? res.data.timeAndSessionIdDtoList.map((e) => { return e.sessionId }) : [];
            // courseId && sessionId 集合
            this.isUseCourseAndSessionIds = res.data.timeAndSessionIdDtoList ? res.data.timeAndSessionIdDtoList.map((e) => { return { courseId: e.courseId, sessionId: e.sessionId } }) : [];

            // (6) 配置自定义字段信息(先)
            res.data.extData.forEach((item) => {
              // (7) 自定义字段为 "省市" ==> 配置联动
              if (item.type == "provinceCity" && item.value) {
                this.customForm[item.name] = item.value.split(",");
                this.provinceCity.push(item.name);
              } else {
                this.customForm[item.name] = item.value;
              }
            });
            // (8) 配置表单信息(后)
            this.customForm = Object.assign({}, this.customForm, {
              id: res.data.id,
              planId,
              realName: res.data.realName,
              cardType: res.data.cardType,
              cardNo: res.data.cardNo,
              sex: res.data.sex,
              phone: res.data.phone,
              email: res.data.email,
              schoolId: res.data.school.state == 1 ? res.data.school.id : "",
              stationId: res.data.station && res.data.station.state == 1 ? res.data.station.id : "",
              address: res.data.address,
              photo: res.data.photoUrl,
              photoDefault: res.data.photo,
              placeId: res.data.place ? res.data.place.id : "",
            });

            // (9) 图片是否处理
            this.changePhoto = true;
            this.changePhotoDefault = true;
            // (10) 课程列表

            // (11) 课程列表默认选中
            if (res.data.course) {
              this.customForm.checkList = res.data.course.map(
                (item) => item.courseId
              );
              if (this.signCoureCount == 1) {
                this.customForm.checkList = this.customForm.checkList.join(",");
              }
            }

            // (12) 用户信息是否配置完成
            this.isReadySignUp = true;
            // (13) 获取到时间(考点可用)
            if (this.isUseTestSite) {
              this.getListTime();
            }

            return getPlaceList({
              planId,
              stationId: this.customForm.stationId,
            });
          })
          .then((res) => {
            this.placeListInfo = res.data;
            if (res.data.length == 1) {
              this.customForm.placeId = res.data[0].placeId;
            }
          });
      } else {
        this.isReadySignUp = true;
        this.timeAndSessionIdDtoList = [];
        this.customForm.courseSessionIds = [];
      }
    },
    /**
     * @param { 删除照片上传记录 }
     */
    deletePicLog() {
      let params = {
        cardNo: this.customForm.cardNo,
        planId: this.customForm.planId,
      }
      this.$api.applyManage.deleteDish(params).then((res) => {
        if (res.code) {
          this.$message.success("已删除照片上传记录");
        }
      });
    },

    /***************************************
     * @this 处理出生日期
     ***************************************/
    autoSetBitrhday(val) {
      let { cardType } = this.customForm;
      let birthday = "";
      if (cardType === 1) {
        if (val.length == 15) {
          birthday = "19" + val.substr(6, 6);
        } else if (val.length == 18) {
          birthday = val.substr(6, 8);
        }
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
        this.customForm[this.birthday] = birthday;
      }
    },

    /***************************************
     * @this 获取报考课程列表
     ***************************************/
    getCourse() {
      // let planId = this.$route.query.planId;
      this.$api.applyManage
        .getPlanCourse({ planId: this.customForm.planId })
        .then((res) => {
          if (res.code && res.data.length > 0) {
            this.courseList = res.data;
            res.data.map((e) => {
              this.courseListConst.push(e.courseId);
            });

            if (!this.$route.query.stuid && res.data.length === 1) {
              this.customForm.courseId = [res.data[0].courseId];
            }
          }
        });
    },

    /***************************************
     * @beforeAvatarUpload 图片上传
     ***************************************/
    beforeAvatarUpload(fileData) {
      let ImgRules = this.planInfo.photoFormat.split(",");
      let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1);
      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < this.planInfo.photoSize;

      if (!isJPG && !isLt30kb) {
        this.$message.error(`该批次上传图片只能是 ${ this.planInfo.photoFormat } 格式，且大小不能超过${ this.planInfo.photoSize } kb! `);
      } else if (!isJPG) {
        this.$message.error(`该批次上传图片只能是 ${ this.planInfo.photoFormat } 格式!`);
      } else if (!isLt30kb) {
        this.$message.error(`该批次上传图片大小不能超过 ${ this.planInfo.photoSize } kb!`);
      }

      return isJPG && isLt30kb;
    },

    /***************************************
     * @beforeAvatarUploadExt 自定义图片上传
     ***************************************/
    beforeAvatarUploadExt(fileData, fileType, fileSize) {
      let ImgRules = fileType.split(",");
      let key = "";
      for (let i = 0; i < ImgRules.length; i++) {
        if (ImgRules[i] == "jpg") {
          key = i;
        }
      }
      ImgRules[key] = "jpeg";
      let type = fileData.type.split("/")[1];
      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < fileSize;
      if (!isJPG) {
        this.$message.error(`上传图片只能是 ${fileType} 格式!`);
      }
      if (!isLt30kb) {
        this.$message.error(`上传图片大小不能超过 ${fileSize} kb!`);
      }
      return isJPG && isLt30kb;
    },

    /***************************************
     * @this 学生照片(固定字段)
     ****************************************/
    uploadImg(data) {
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.customForm.photo = e.currentTarget.result;
        }
      };
      this.changePhoto = false;
    },

    /**
     * @param { 2024年1月16日 -- 基础照片 }
     */
    uploadImgUrl(data) {
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.customForm.photoDefault = e.currentTarget.result;
        }
      };
      this.changePhotoDefault = false;
    },

    /**************************************
     * @this 图片文件上传(自定义)--数据配置
     **************************************/
    uploadImgExt(data) {
      //判断是否选择批次
      if (!this.customForm.planId) {
        this.$message.error("请选择批次");
        return;
      }
      // 1. 获取对应字段
      let attr = data.data[0];
      // 2. 获取文件
      let fileData = data.file;
      // 3. 获取文件类型,尾缀
      let fileTypeLast = data.file.name.lastIndexOf(".");
      let fileType = "";
      if (fileTypeLast !== -1) {
        fileType = data.file.name.slice(fileTypeLast + 1).toLowerCase();
      } else {
        return false;
      }
      // 4. 调用文件上传接口
      this.upLoadSstate(fileData, fileType, attr);
    },

    /**************************************
     * @this 图片文件上传(自定义)--图片上传
     **************************************/
    upLoadSstate(fileData, fileType, attr) {
      // 1. 调用参数准备
      let formData = new FormData();
      formData.append("upfile", fileData);
      formData.append("fileType", fileType);
      formData.append("planId", this.customForm.planId);
      // 2. 设置文件反显
      uploadExtSet(formData).then((res) => {
        this.customForm[attr] = res.data;
      });
    },

    /***************************************
     * @this 保存/修改
     ***************************************/
    save() {
      this.$refs["customForm"].validate((valid) => {
        if (valid) {
          //如果手机号不是必填，但是还填写了内容，则要对手机号进行合法性的判断
          if(this.baseDefList.isShowPhone && !this.baseDefList.isMastPhone && this.customForm.phone){
            if(!/^1[3-9]\d{9}$/.test(this.customForm.phone)){
              this.$message.error("请输入正确的手机号");
              return;
            }
          }
          //如果手机号不是必填，但是还填写了内容，则要对手机号进行合法性的判断
          if(this.baseDefList.isShowEmail && !this.baseDefList.isMastEmail && this.customForm.email){
            if(!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.customForm.email)){
              this.$message.error("请输入正确的邮箱");
              return;
            }
          }
          // savePhoto 暂存修改之前的照片数据
          this.savePhoto = this.customForm.photo;
          this.savePhotoDefault = this.customForm.photoDefault;

          if (!this.changePhotoDefault && this.customForm.photoDefault) {
            this.customForm.photoDefault = this.customForm.photoDefault.split(",")[1];
          }

          // 1. 照片格式处理
          if (!this.changePhoto) {
            this.customForm.photo = this.customForm.photo.split(",")[1];
          }
          // 2. 设置用户默认密码
          let password = this.dealPassword(this.customForm.cardNo);
          // 3. 处理 省市级联
          for (let key in this.customForm) {
            if (this.provinceCity.includes(key)) {
              this.customForm[key] = this.customForm[key].toString();
            }
          }
          // 去重
          if (this.signCoureCount == 0) {
            this.customForm.checkList = Array.from(
              new Set(this.customForm.checkList)
            );
            this.customForm.courseId = this.customForm.checkList.join(",");
          }else{
            this.customForm.courseId = this.customForm.checkList
          }
          let saveState = this.customForm.id
            ? UpdateRegistration
            : addStudentExtSet;
          let params = {
            ...this.customForm,
            password,
            confirmPassword: password,
          };

          let photoUrl = this.customForm.photo;
          let photo = this.customForm.photoDefault;

          params.photo = photo;
          params.photoUrl = photoUrl;

          delete params.checkList;
          delete params.photoDefault;

          /* ** 处理科目,时间 => 只保留课程id, 场次id *** */
          let courseSessionIds = [];
          params.courseSessionIds.map((e) => {
            if (e.courseId && e.sessionId) {
              let par = {
                courseId: e.courseId,
                sessionId: e.sessionId,
              };
              courseSessionIds.push(par);
            }
          });
          // 考点开启, 课程时间集合为必要参数
          if (this.isUseTestSite && courseSessionIds.length == 0) {
            this.$message.error("请选择要考试的科目&场次");
          } else {
            // 科目,时间集合 JOSN 转为 String
            params.courseSessionIds = this.isUseTestSite
              ? JSON.stringify(courseSessionIds)
              : "";

            // 添加/修改失败, 照片重新赋值, 避免二次上传
            this.customForm.photo = this.savePhoto;
            this.customForm.photoDefault = this.savePhotoDefault;
            // 编辑, 管理端新增参数, 用户标记改信息为管理端接口修改
            if (this.customForm.id) {
              params.isManage = 1;
            }
            // 3. 有id编辑，没有id添
            saveState(params)
              .then((res) => {
                if (res.code == 1) {
                  this.$message({
                    message: this.customForm.id ? "修改成功" : "添加成功",
                    type: "success",
                  });
                  this.$event.$emit("getData");
                  this.$router.push({ name: "applyManage" });
                } else {
                  this.customForm.courseSessionIds = [];
                }
              })
              .catch((err) => {
                this.customForm.courseSessionIds = [];
              });
          }
        }
      });
    },

    /***************************************
     * @this 创建成功,设置用户默认密码
     ***************************************/
    dealPassword(cardNo) {
      let resetPassword = "";
      let hanzi = new RegExp("[\u4e00-\u9fa5]");
      if (hanzi.test(cardNo)) {
        resetPassword = "000000";
      } else if (cardNo.length >= 6) {
        resetPassword = cardNo.substring(cardNo.length - 6).toUpperCase();
      } else {
        let zeroNum = 6 - cardNo.length;
        for (let i = 0; i < zeroNum; i++) {
          resetPassword = resetPassword + "0";
        }
        resetPassword = resetPassword + cardNo;
      }
      return resetPassword;
    },

    /***************************************
     * @this 添加成功--返回
     ***************************************/
    goBack() {
      this.$router.go(-1);
    },

    /**
     * @param { 所选批次信息 }
     */
    async getPlan() {
      const { planId } = this.customForm;
      const { data } = await this.$api.applyManage.getCurrentPlan({ planId })
      // 当前批次信息
      this.planInfo = data;
      // 当前批次是否设置了 "报名选择考点场次"
      this.isUseTestSite = data.optionalSession == 1;
      // 表单上传参数 "报名选择考点场次"
      this.customForm.optionalSession = data.optionalSession;
      this.signCoureCount = data.signCoureCount;
      this.optionalExam = data.optionalExamDate;

      // 设置默认图片配置 (格式/大小)
      if (!this.planInfo.photoFormat) {
        this.planInfo.photoFormat = "jpg";
      }
      if (!this.planInfo.photoSize) {
        this.planInfo.photoSize = "2048";
      }

    },
  },
};
</script>

<style lang="less" scoped>
.applyManageAddBox {
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  .time .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 240px;
  }
  h1 {
    color: #2d2f33;
    font-size: 20px;
    padding-bottom: 24px;
  }
  h2 {
    font-size: 16px;
    color: #2d2f33;
    padding: 32px 0;
    border-top: 1px solid #f1f2f5;
  }
  /deep/ .el-input__inner {
    width: 240px;
    height: 36px;
  }
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    .upLoadSstate {
      position: absolute;
      left: 30px;
      top: 100px;
    }
  }
  .avatar-uploader .el-upload:hover {
    border-color: #006aff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 116px;
    height: 152px;
    line-height: 152px;
    text-align: center;
  }
  .avatar {
    width: 116px;
    height: 152px;
  }
  .avatarTip {
    display: flex;
    padding-top: 8px;
    vertical-align: top;
    line-height: 1.8;
  }
  .dbi {
    display: inline-block;
  }
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 116px;
    height: 152px;
  }
  .avatar-uploader /deep/ .el-upload:hover {
    border-color: #006aff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
  }
  .avatar-uploader /deep/ .el-upload:hover .avatar-uploader-icon {
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 3;
  }
}
.address /deep/ .el-textarea__inner {
  width: 70%;
}
.upload-img {
  .photo {
    width: 116px;
    height: 152px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/ .el-form-item__content {
    display: flex;
  }
}
.upload-tips {
  padding-left: 10px;
}
/deep/ .el-radio-button__inner {
  margin-right: 16px;
  margin-bottom: 11px;
  color: #45494d !important;
  background: #f4f5f8 !important;
  font-size: 13px;
  border-radius: 4px !important;
  border: 1px solid #dadde6 !important;
  padding: 10px 20px;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #ebf5ff !important;
  border: 1px solid #006aff !important;
  color: #006aff !important;
  box-shadow: none;
}
.examType {
  margin: 0 16px 11px 0;
  /deep/ .el-radio-button__inner {
    margin: 0 !important;
  }
}
/* ** 课程场次样式 (禁用) ** */
.examType.is-disabled {
  /deep/ .el-radio-button__inner {
    color: #c2c6cc !important ;
    background-color: #f1f2f5 !important ;
    border: 1px solid #dadde6 !important ;
  }
}
.examType.is-active {
  /deep/ .el-radio-button__inner {
    color: #006aff !important ;
    background-color: #ebf5ff !important ;
    border: 1px solid #006aff !important ;
  }
}
.examType.is-disabled.is-active {
  /deep/ .el-radio-button__inner {
    color: #006aff !important ;
    background-color: #f1f2f5 !important ;
    border: 1px solid #006aff !important ;
  }
}
/* 2021/11/26 IE 表单样式问题(盒模型大小同谷歌有异) */
/deep/ .el-input .el-input__inner {
  width: 240px;
  height: 36px;
  line-height: 18px;
}
.timeClass{
  /deep/.el-input {
    width: 300px;
   
  }
  /deep/.el-input__inner{
    width: 300px;
  }
}
.photo{
  img{
    width: 116px;
    height: 152px;
  }
}
</style>
